var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontalAlignCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15794_139167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 16V13L23 13V11H19V8L15 12L19 16ZM5 8V11H1V13H5V16L9 12L5 8ZM11 20H13L13 4H11L11 20Z",
    fill: "#303238"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15794_139167"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(0 -1 1 0 0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalAlignCenter);
export default __webpack_public_path__ + "static/media/horizontal_align_center.c89eff145b04fbf6ffc3f8b25b96eb30.svg";
export { ForwardRef as ReactComponent };